"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("h2", {
  className: "text-primary"
}, "Exporting the Competitions Calendar as a JSON File");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Slalom competitions are initially recorded as Applications during the previous season. Once approved at the slalom ACM, the applications are transferred to become competitions on the entry system. Although, in theory, the calendar is fixed at this point, changes regularly happen, including cancellations, date changes and additional competitions.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Please note this API applies to the current \"live\" competitions as set up for entries and not the calendar application system.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "Details of competitions can be extracted in the form of a JSON file by running", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/competitions"
}, "www.canoeslalomentries.co.uk/export/competitions"), ' ');
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "This will return all Competitions in whatever year the entries system considers to be current. For the most part this aligns to the calendar year, but the system will usually switch to the next year in December", ' ');
var _ref6 = /*#__PURE__*/_react.default.createElement("p", null, "You can specify the actual year you require with a parameter. Eg for 2024:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/competitions?yearID=2024"
}, "www.canoeslalomentries.co.uk/export/competitions?yearID=2024"));
var _ref7 = /*#__PURE__*/_react.default.createElement("p", null, "The export returns a JSON object containing two object arrays:");
var _ref8 = /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "publishedCompetitions: these have been checked by the organiser and published for view."), /*#__PURE__*/_react.default.createElement("li", null, "unpublishedCompetitions: these have been approved for the calendar but are awaiting checks and therefore only a very limited amount of data is available."));
var _ref9 = /*#__PURE__*/_react.default.createElement("p", null, "The format of the JSON output is as follows. This may be added to by request");
var _ref10 = /*#__PURE__*/_react.default.createElement("p", null, '{');
var _ref11 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "text-primary"
}, "Exporting the Competitions Days List as a csv File");
var _ref12 = /*#__PURE__*/_react.default.createElement("p", null, "This extract provides a list of published competition Day, ie Saturday and Sunday, say, are listed separately. Days may include training days where no actual racing takes place.");
var _ref13 = /*#__PURE__*/_react.default.createElement("p", null, "Details of published competitions can be extracted in the form of a JSON file by running", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/competition-days-lookup"
}, "www.canoeslalomentries.co.uk/export/competition-days-lookup"), ' ');
var _ref14 = /*#__PURE__*/_react.default.createElement("p", null, "This will return all published Competitions in whatever year the entries system considers to be current. For the most part this aligns to the calendar year, but the system will usually switch to the next year in late December", ' ');
var _ref15 = /*#__PURE__*/_react.default.createElement("p", null, "You can specify the actual year you require with a parameter. Eg for 2025:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/competition-days-lookup?yearID=2025"
}, "www.canoeslalomentries.co.uk/export/competition-days-lookup?yearID=2025"));
var _ref16 = /*#__PURE__*/_react.default.createElement("p", null, "The export returns a csv object containing published Competitions that have been checked by the organiser and published for view.");
var _ref17 = /*#__PURE__*/_react.default.createElement("p", null, "The data provided is as follows");
var _ref18 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "text-primary"
}, "Exporting Competition Divisions to Tiers csv File");
var _ref19 = /*#__PURE__*/_react.default.createElement("p", null, "During the transition from running races based on divisions to using the new tier format this export will provide a set of data similar to the Competition Days list above, but with additional rows to show the current race divisions and an approximation of the equivalent tier. Normally the tier will be the same for all divisions run on the same day, but there may be exceptions, eg Pinkston, where the divisions may be running on different numbers of pumps. Note that Opens and Officials are not included in this list.");
var _ref20 = /*#__PURE__*/_react.default.createElement("p", null, "The data will include all of that in the Competition Days List above plus additional columns as follows");
var _ref21 = /*#__PURE__*/_react.default.createElement("p", null, "Note that as before the export will only include published Competitions");
var _ref22 = /*#__PURE__*/_react.default.createElement("p", null, "The current year data is at:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/divisions-to-tiers"
}, "www.canoeslalomentries.co.uk/export/divisions-to-tiers"));
var _ref23 = /*#__PURE__*/_react.default.createElement("p", null, "2025 data is at:", ' ', /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/divisions-to-tiers?yearID=2025"
}, "www.canoeslalomentries.co.uk/export/divisions-to-tiers?yearID=2025"));
var _ref24 = /*#__PURE__*/_react.default.createElement("h2", {
  className: "text-primary"
}, "Exporting TSP mapping to Expected Points as a csv File");
var _ref25 = /*#__PURE__*/_react.default.createElement("p", null, "From 2027 onwards, all ranked paddlers will have a Two-Season-Pecentile (TSP) which is based on the average of their best three results over the current and previous season. Unranked paddlers will have a TSP of 100, team members will have a TSP of 0.");
var _ref26 = /*#__PURE__*/_react.default.createElement("p", null, "Given the TSP for a paddler and the Tier at which they are competing, the Expected Points (EP) for the paddler can be derived. At an individual event the highest EP will become the overall Winners Points for that event.");
var _ref27 = /*#__PURE__*/_react.default.createElement("p", null, "Any paddler who achieves or betters their EP has performed above expectations. Whereas a paddler who achieves less than their EP has performed a bit below par.");
var _ref28 = /*#__PURE__*/_react.default.createElement("p", null, "This mapping will remain static unless the calculation parameters in the rules are amended. It downloads in csv format and can be extracted by running:", /*#__PURE__*/_react.default.createElement("a", {
  href: "/export/tsp-expected-points"
}, "www.canoeslalomentries.co.uk/export/tsp-expected-points"));
var _ref29 = /*#__PURE__*/_react.default.createElement("p", null, "The data provided is as follows");
const CompetitionsAPIHelp = () => {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled",
    style: {
      marginLeft: '2em',
      color: 'blue'
    }
  }, /*#__PURE__*/_react.default.createElement("li", null, "id: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "number,"), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// unique competition integer")), /*#__PURE__*/_react.default.createElement("li", null, "isPublished: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "boolean, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// indicates whether competition details are published, always TRUE for published competitions")), /*#__PURE__*/_react.default.createElement("li", null, "isCancelled: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "boolean, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// indicates whether competition has been cancelled")), /*#__PURE__*/_react.default.createElement("li", null, "competitionName: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name of competition, eg Llandysul Div 1/2")), /*#__PURE__*/_react.default.createElement("li", null, "subtitle: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// subtitle, eg Selection")), /*#__PURE__*/_react.default.createElement("li", null, "title: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Title is name and subtitle concatenated")), /*#__PURE__*/_react.default.createElement("li", null, "startDate: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// date is in form yyyy-mm-dd - there is no time part")), /*#__PURE__*/_react.default.createElement("li", null, "numberOfDays: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "number, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Although most competitions are run over two days, some will be single days. If there is paid for practice on another day then this will be included")), /*#__PURE__*/_react.default.createElement("li", null, "club: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// if two clubs are co-organising this will be a single string with both club names")), /*#__PURE__*/_react.default.createElement("li", null, "organiser: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// organiser name")), /*#__PURE__*/_react.default.createElement("li", null, "contactEmail: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, ")), /*#__PURE__*/_react.default.createElement("li", null, "openForEntries: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// the date when competition opens for entries yyyy-mm-dd - there is no time part")), /*#__PURE__*/_react.default.createElement("li", null, "closedForOnlineEntryDate: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// the date when competition no longer accepts on-line entries yyyy-mm-dd - there is no time part. Last opportunity for on-line entries is day before. Note some entries eg Officials may be accepted online for longer.")), /*#__PURE__*/_react.default.createElement("li", null, "lateFeesApplyDate: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// the date when late fees start to be charged. Set to null if late fees are not charged at all.")), /*#__PURE__*/_react.default.createElement("li", null, "entryLink: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// entry link is url to the entries homepage as a string")), /*#__PURE__*/_react.default.createElement("li", null, "onDayEntriesAccepted: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "boolean, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// A lot of the lower divisions accept entries on the day; higher divisions rarely do")), /*#__PURE__*/_react.default.createElement("li", null, "entryFees: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string[], "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// first array item will be \"Standard Fees Apply\" or \"Enhanced Fees Apply\"; 2nd item (if it exists) will be actual fees by division as a single string")), /*#__PURE__*/_react.default.createElement("li", null, "description: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "RichText | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// RichText is of form ", '{', "__html: number", '}', ". Description can be very long in some cases; particularly true of Selection and Interclubs")), /*#__PURE__*/_react.default.createElement("li", null, "calendarInfo: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string[], "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Calendar info is that added at application time and is much shorter that the description which can be quite excessive; sent as a string array for line splitting")), /*#__PURE__*/_react.default.createElement("li", null, "startListLink: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// if the start list has been published will be a URL string otherwise will be null")), /*#__PURE__*/_react.default.createElement("li", null, "entryLimits: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// entry limits shown as a single number in string format (eg \"150\") if the same each day or as a string for different days (eg Sat: 200, Sun: 150)")), /*#__PURE__*/_react.default.createElement("li", null, "siteID: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// rarely null, but can be for historical data")), /*#__PURE__*/_react.default.createElement("li", null, "location: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name by which slalom site is known eg Lee Valley Olympic or Lee Valley Legacy")), /*#__PURE__*/_react.default.createElement("li", null, "postCode: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Suggested postcode for sat navs")), /*#__PURE__*/_react.default.createElement("li", null, "latitude: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site latitude")), /*#__PURE__*/_react.default.createElement("li", null, "longitude: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site longitude")), /*#__PURE__*/_react.default.createElement("li", null, "what3words: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// The 3 words pointing at site location")), /*#__PURE__*/_react.default.createElement("li", null, "webSlug: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// this points to the site information page on www.canoeslalom.co.uk")), /*#__PURE__*/_react.default.createElement("li", null, "county: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site county")), /*#__PURE__*/_react.default.createElement("li", null, "nation:", ' ', /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "'England' | 'Wales' | 'Scotland' | 'Northern Ireland' | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Based on site location")), /*#__PURE__*/_react.default.createElement("li", null, "divisions: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string[], "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "//Divisions for competitions. These do not need to be displayed as they are incorporated into the competition Title, but they can be used for filtering")), /*#__PURE__*/_react.default.createElement("li", null, "competitionDayIDs: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, '{[key:string]: number]}[],'), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "//UID for each day of competition by the date - this may include days on which there is practice but no racing."))), '}', "[]"), /*#__PURE__*/_react.default.createElement("ul", null, "unPublishedCompetitions: ", '{', /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled",
    style: {
      marginLeft: '2em',
      color: 'blue'
    }
  }, /*#__PURE__*/_react.default.createElement("li", null, "id: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "number,")), /*#__PURE__*/_react.default.createElement("li", null, "isPublished: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "boolean,")), /*#__PURE__*/_react.default.createElement("li", null, "isCancelled: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "boolean, ")), /*#__PURE__*/_react.default.createElement("li", null, "competitionName: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name of competition, eg Llandysul Div 1/2")), /*#__PURE__*/_react.default.createElement("li", null, "startDate: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// date is in form yyyy-mm-dd - there is no time part")), /*#__PURE__*/_react.default.createElement("li", null, "numberOfDays: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "number, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Although most competitions are run over two days, some will be single days. If there is paid for practice on another day then this will be included")), /*#__PURE__*/_react.default.createElement("li", null, "club: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// if two clubs are co-organising this will string the clubs together")), /*#__PURE__*/_react.default.createElement("li", null, "siteID: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// rarely null, but can be for historical data")), /*#__PURE__*/_react.default.createElement("li", null, "location: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name by which slalom site is known eg Lee Valley Olympic or Lee Valley Legacy")), /*#__PURE__*/_react.default.createElement("li", null, "postCode: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Suggested postcode for sat navs")), /*#__PURE__*/_react.default.createElement("li", null, "latitude: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site latitude")), /*#__PURE__*/_react.default.createElement("li", null, "longitude: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site longitude")), /*#__PURE__*/_react.default.createElement("li", null, "what3words: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// The 3 words pointing at site location")), /*#__PURE__*/_react.default.createElement("li", null, "webSlug: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// this points to the site information page on www.canoeslalom.co.uk")), /*#__PURE__*/_react.default.createElement("li", null, "county: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Site county")), /*#__PURE__*/_react.default.createElement("li", null, "nation:", ' ', /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "'England' | 'Wales' | 'Scotland' | 'Northern Ireland' | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Based on site location"))), '}', "[]")), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled",
    style: {
      marginLeft: '2em',
      color: 'blue'
    }
  }, /*#__PURE__*/_react.default.createElement("li", null, "Date: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string in format \"yyyy-mm-dd\","), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// date of the competition day")), /*#__PURE__*/_react.default.createElement("li", null, "competitionName: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name of competition, eg Llandysul Div 1/2")), /*#__PURE__*/_react.default.createElement("li", null, "location: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Name by which slalom site is known eg Lee Valley Olympic or Lee Valley Legacy")), /*#__PURE__*/_react.default.createElement("li", null, "club: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string | null, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// if two clubs are co-organising this will be a single string with both club names")), /*#__PURE__*/_react.default.createElement("li", null, "competitionDayID: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// UID for the competition Day.")), /*#__PURE__*/_react.default.createElement("li", null, "isPublished: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "TRUE/FALSE, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// indicates whether competition details are published, always TRUE for published competitions")), /*#__PURE__*/_react.default.createElement("li", null, "isCancelled: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "TRUE/FALSE, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// indicates whether competition has been cancelled")))), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref18, _ref19, _ref20, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled",
    style: {
      marginLeft: '2em',
      color: 'blue'
    }
  }, /*#__PURE__*/_react.default.createElement("li", null, "Division: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string,"), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// \"Prem\", \"Div 1\", \"Div 2\", \"Div 2\", or \"Div 4\"")), /*#__PURE__*/_react.default.createElement("li", null, "NewTier: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// \"DMND\", \"BLCK\", \"RED\", \"BLUE\", or \"GRN\""))), _ref21, _ref22, _ref23), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled",
    style: {
      marginLeft: '2em',
      color: 'blue'
    }
  }, /*#__PURE__*/_react.default.createElement("li", null, "Key: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string,"), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// a combination of tier, event an tsp for use as a lookup column")), /*#__PURE__*/_react.default.createElement("li", null, "Tier: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// A code that represents the Tier ")), /*#__PURE__*/_react.default.createElement("li", null, "Event: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "string, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// Event class: C1M, C1W, C2, K1M, K1W")), /*#__PURE__*/_react.default.createElement("li", null, "TSP: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "integer, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// A number between 0 and 100")), /*#__PURE__*/_react.default.createElement("li", null, "ExpectedPoints: ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'brown'
    }
  }, "integer, "), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: 'green'
    }
  }, "// The number of points that a paddler with this TSP should achieve at the corresponding Tier and Event.")))));
};
var _default = exports.default = CompetitionsAPIHelp;